// Single source of truth for the film taxonomy.
// Used by the Films page filters, the public Submit Film form, and the Admin
// add/edit form. Keep additions/removals here so all surfaces stay in sync.

// Length describes the runtime/format of the film.
export const FILM_LENGTHS = [
  "Short",
  "Mid-length",
  "Feature",
  "Series/Anthology",
];

// Genres describe content/style. A film can have multiple genres.
// Adult content is intentionally excluded.
export const FILM_GENRES = [
  "Drama",
  "Documentary",
  "Comedy",
  "Romance",
  "Costume Drama",
  "Animation",
  "Experimental",
  "Thriller",
  "Mystery",
  "Sci-Fi",
  "Fantasy",
  "Horror",
  "Musical",
  "Family",
  "Biopic",
  "Action",
];
